import React from 'react';

/**
 * Hook for detecting a top scroll within an element
 * @param elementRef DOM element to detect the top scroll
 * @returns the boolean indicating that there is a top scroll
 */
export const useScrollTop = (elementRef: HTMLElement) => {
  const [isTopScrolling, setIsTopScrolling] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = event => {
      setIsTopScrolling(elementRef.scrollTop > 0);
    };

    if (elementRef) {
      elementRef.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (elementRef) {
        elementRef.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return isTopScrolling;
};

export default useScrollTop;
